import { IPlayerError } from '../../types/interfaces/error';
import { store } from '../../store/store';
import { setError } from '../../store/slices/media.slice';

function displayError(error: IPlayerError) {
  const { app } = store.getState();
  if (app.status.network) store.dispatch(setError(error));
}

export default displayError;
